import { Routes } from '@angular/router';

export const SEU_APP_ROUTES: Routes = [
  {
    path: 'styleguide1234',
    loadChildren: () =>
      import('./styleguide/styleguide.routing').then((m) => m.StyleguideRoutes),
  },
  {
    path: '',
    loadChildren: () =>
      import('./process-designer/process-designer.routing').then(
        (m) => m.ProcessDesignerRoutes
      ),
  },
];
